module.exports = __webpack_public_path__ + "img/loading.f07067f7.svg";